import { useInfiniteQuery, useQuery } from '@tanstack/react-query';
import * as _a from '@/lib/api';
import queryClient from '@/lib/queryClient';

export const usePlaylists = () => {
  return useQuery({
    queryKey: ['playlists'],
    queryFn: () => _a.playlists(),
  });
};
